<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت فرم تماس با ما</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                <v-card>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md6 lg6 xl6 style="padding-right:15px;padding-left:15px;">
                                <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchcategory" append-icon="fas fa-search"></v-text-field>   
                            </v-flex>
                            <v-flex xs12 sm12 md3 lg3 xl3 style="padding-right:15px;padding-left:15px;">
                                <v-autocomplete @change="FilterContent($event)" item-text="text" item-value="value" outlined dense :items="FilterItems" color="#262d47" placeholder="فیلتر کنید" append-icon="fas fa-filter"></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm12 md3 lg3 xl3 style="padding-right:15px;padding-left:5px;">
                                
                                <JsonExcel style="display: inline-block;padding-left: 5px;" :data="originalItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                                </JsonExcel>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingCats" :headers="CatTableHeader" :search="searchcategory" :items="CatTableItems">
                            <template v-slot:[`item.l_Status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.l_Id)" dark v-if="!item.l_Status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.l_Id)" dark v-else> فعال</v-btn>
                            </template>
                            <template v-slot:[`item.f_MsgType`]="{ item }">
                                <v-chip small style="font-weight:bold;background:transparent;">{{GetMsgType(item.f_MsgType)}}</v-chip>
                            </template>
                            <template v-slot:[`item.l_Logo`]="{ item }">
                                <v-btn target="_blank" :href="LogoUrl+`${item.l_Logo}`" icon small><v-icon small>fas fa-eye</v-icon></v-btn>
                            </template>
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="blue accent-4" @click="editItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                                <v-btn text icon small color="red accent-4" @click="confirmDeleteItem(item.l_Id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                            </template>
                            <template v-slot:[`item.created_At`]="{ item }">
                               {{ConvertDate(item.created_At)}}
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
       
        
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
      
    </div>
</template>
<style>
.v-color-picker__canvas canvas
{
    display: block !important;
    min-width: 100% !important;
    height: 100% !important;
}
</style>
<style scoped>
.overFlowHidden .v-dialog:not(.v-dialog--fullscreen)
{
    overflow: hidden !important;
}
.overFlowHidden 
{
    max-width: 400px;
    max-height: 400px;
    overflow: hidden !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}
.operationBoxDesign
{
    display: flex;
    align-items: center;
    border-radius: 0px;
    justify-content: space-evenly;
    min-height: 50px;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 10px;
    padding-left: 10px;
    /* border: 1px solid rgb(207, 207, 207); */
    background-color: #fff;
    margin-bottom: 4px;
    box-shadow: 0px 0px 4px rgba(207, 207, 207,0.5);
}
</style>
<script>
const axios = require("axios");
const ApiUrl = require('../../constant/apiurl');
const MSGHNDL = require('../../constant/MessageHandler');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import JsonExcel from 'vue-json-excel'
export default {
    name:"suggestForm",
   components: {
            Loading,
            JsonExcel
        },
    data:()=> ({
        isLoading:false,
        isLoadingCats:false,
        CatTableHeader:
        [
           {text:"#",value:"Counter",sortable:true,align:"right"},
            {text:"نوع پیام",value:"f_MsgType",sortable:true,align:"right"},
            {text:"نام و نام خانوادگی",value:"f_User",sortable:true,align:"right"},
            {text:"تلفن همراه",value:"f_UserPhone",sortable:true,align:"right"},
            {text:"پست الکترونیکی",value:"f_UserEmail",sortable:true,align:"right"},
            {text:"متن ",value:"f_Msg",sortable:true,align:"right"},
            {text:"تاریخ ثبت ",value:"date",sortable:true,align:"right"}
        ],
        CatTableItems:
        [
        ],
        originalItems:[],
        ExportDataColumns:{
            "نوع پیام":"f_MsgType",
            "نام و نام خانوادگی":"f_User",
            "تلفن همراه":"f_UserPhone",
            "پست الکترونیکی":"f_UserEmail",
            "متن":"f_Msg",
            "تاریخ ثبت ":"date",
        },
        FilterItems:[
            {text:" پاک کن",value:0},
            {text:"انتقاد",value:1},
            {text:"پیشنهاد",value:2},
            {text:"شکایت",value:3},
            {text:" پیگیری",value:4},
        ]
    }),
    async created()
    {
        let vm = this;
        vm.LogoUrl = ApiUrl.PLabelLogo;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadCategories();
       this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
    },
    methods:{
        FilterContent(e)
        {
            let vm= this;
            if(e == 0)
            {
                vm.CatTableItems = vm.originalItems;
            }
            else
            {
                vm.CatTableItems = vm.originalItems.filter((i)=>{
                    if(i.f_MsgType == e)
                    {
                        return i;
                    }
                });
            }
        },
        GetMsgType(t)
        {
            var Types = {1:"انتقاد",2:"پیشنهاد",3:"شکایت",4:" پیگیری"};

            return Types[t];
        },
        ConvertDate(date)
        {
            return new Date(Date.parse(date)).toString().replace(/\S+\s(\S+)\s(\d+)\s(\d+)\s.*/,'$2-$1-$3');
        },

       
        async loadCategories()
        {
            let vm = this;
            vm.isLoadingCats = true;

            await axios.post(ApiUrl.LoadPublicForms+'/1').then(async (res)=>{
                vm.isLoadingCats = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CatTableItems = data.data;
                    vm.originalItems = data.data;
                }
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },
       
    }
}
</script>